import { IMaskMixin } from 'react-imask';
import { Input } from '@zep/ui';
export const MaskedInput = IMaskMixin(({
  inputRef,
  ...props
}) => <Input {...props as any} ref={inputRef} size={props.size} type="text" isFullWidth />);